import React, { useState, useEffect, useRef } from "react";
import { Box, Dialog, DialogContent } from "@material-ui/core";
import {
    ColumnName,
    commonInputStyles,
    SavingSpinnerForColumnEditors,
    ActionButtonsForColumnEditors,
    handleClose,
    ErrorMessageViewer
} from "./ColumnEditorFactory";
import { validateBooleanInputsBeforeSaving } from "../RowId/Validations";

const BooleanReusableEditor = ({
    initialValue = "0",
    open,
    data,
    column,
    columnName,
    onSave,
    onCancel
    }) => {
    const [value, setValue] = useState(initialValue === "1" ? "1" : "0");
    const [isSaving, setIsSaving] = useState(false);
    const [validationError, setValidationError] = useState({ isInvalid: false, message: "" });
    const containerRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        if (open) {
        setValue(initialValue ?? "");
        const timer = setTimeout(() => {
            if (inputRef.current) {
            inputRef.current.focus();
            }
        }, 50);
        return () => clearTimeout(timer);
        }
    }, [initialValue, open]);

    const handleChange = (e) => {
        setValue(prev => prev === "1" ? "0" : "1");
        if (inputRef.current) {
            inputRef.current.focus();
        }
        if (validationError.isInvalid) {
            setValidationError({ isInvalid: false, message: "" });
        }
    };

    const handleSave = async () => {
        setIsSaving(true);
        try {
            if (value === initialValue) {
                onCancel();
                return;
            }

            const isUpdateAllowed = validateBooleanInputsBeforeSaving(column, data);
            if (isUpdateAllowed.isInvalid) {
                setValidationError(isUpdateAllowed);
                return;
            }

            await onSave(value === "1" ? true : false, initialValue, column);
        } catch (err) {
            console.error("Error saving boolean value:", err);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={() =>
                handleClose(value, initialValue, onCancel, validationError, setValidationError)
            }
            fullWidth
            PaperProps={{
                style: {
                    width: "300px",
                    height: validationError.isInvalid ? "190px" : "165px",
                    borderRadius: "8px",
                },
            }}
        >
            <DialogContent>
                <Box
                    ref={containerRef}
                    display="flex"
                    flexDirection="column"
                    style={{ width: "100%", gap: 8 }}
                >
                    {columnName && <ColumnName columnName={columnName} />}
                    <div
                        className="custom-control custom-checkbox"
                        style={{
                            ...commonInputStyles,
                            height: 44,
                            padding: 10,
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                        }}
                        onClick={handleChange}
                    >
                        <input
                            ref={inputRef}
                            type="checkbox"
                            className="custom-control-input"
                            id="defaultChecked"
                            onChange={() => {}}
                            checked={value === "1" ? true : false}
                        />
                        <label className="custom-control-label boolean-checkbox-reusable checkbox-pointer"></label>
                    </div>

                    {validationError.isInvalid && (<ErrorMessageViewer errMsg={validationError.message} />)}

                    <ActionButtonsForColumnEditors
                        handleSave={handleSave}
                        handleCancel={() =>
                            handleClose(value, initialValue, onCancel, validationError, setValidationError)
                        }
                        isSaveDisabled={isSaving}
                        isCloseDisabled={isSaving}
                    />

                    {isSaving && <SavingSpinnerForColumnEditors />}
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default BooleanReusableEditor;